import { useEffect, useState } from 'react';

interface ResponsiveSwitcherProps {
  mobile: React.ReactNode;
  desktop: React.ReactNode;
}

const MOBILE_BREAKPOINT = 768;

/**
 * A component that switches between mobile and desktop views based on the window width.
 * It reacts to window resize events and re-renders the component based on the window width.
 */
export const ResponsiveSwitcher = ({ mobile, desktop }: ResponsiveSwitcherProps) => {
  const isMobile = useIsMobileView();
  return <>{isMobile ? mobile : desktop}</>;
};

/**
 * A hook that returns a boolean indicating whether the current view is mobile or not.
 * It listens to window resize events and updates the state accordingly.
 */
export const useIsMobileView = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < MOBILE_BREAKPOINT);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    };

    window.addEventListener('resize', handleResize);
    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return isMobile;
};
